import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { LoginPageComponent } from './shared/features/auth/pages/login-page/login-page.component';
import { EventDetailPageComponent } from './shared/features/app-pages/pages/event-detail-page/event-detail-page.component';

const routes: Routes = [
  // ROTA FIXA PARA TESTE (sem lazy)
  { path: 'evento', component: EventDetailPageComponent },

  // App com shell
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' }, // abre /login por padrão
      {
        path: '',
        loadChildren: () =>
          import('./shared/features/app-pages/app-pages.module').then(m => m.AppPagesModule),
      },
    ],
  },

  {
  path: 'feedback',
  loadChildren: () =>
    import('./feedback/modules/feedback/feedback-routing.module').then((m) => m.FeedbackRoutingModule),
},

  // Fallback
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      // enableTracing: true, // habilite para diagnosticar
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
